/**
 * @generated SignedSource<<1e4a12e579252d1b98714469557a89d1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerProductCarouselOnly_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductImageCarousel_viewer">;
  readonly " $fragmentType": "BuyerProductCarouselOnly_viewer";
};
export type BuyerProductCarouselOnly_viewer$key = {
  readonly " $data"?: BuyerProductCarouselOnly_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductCarouselOnly_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerProductCarouselOnly_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductImageCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "15a599438d7df8cdeaf3b032a53f0548";

export default node;
